module.exports = __webpack_public_path__ + "img/overview7.2dda8968.png";